import script from "./SetupOnboardingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupOnboardingModal.vue?vue&type=script&setup=true&lang=js"

import "./SetupOnboardingModal.vue?vue&type=style&index=0&id=d1a53fbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1a53fbe"]])

export default __exports__